import React from 'react'
import Roomkrishnagar from "../images/roomkrishnagar.jpeg";
import Deluxeroemkriahnagar from "../images/deluxepremium.jpeg";
import deluxeroom from "../images/roompremium.jpeg";
import premiumdeluxe from "../images/PREMIUM DELUXE.jpg";

function Premiumdeluxepage() {
  return (
    <div>
        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={premiumdeluxe} className="d-block w-100" alt="rannabati"/>
    </div>
    <div className="carousel-item">
      <img src={Deluxeroemkriahnagar} className="d-block w-100" alt="rannabati"/>
    </div>
    <div className="carousel-item">
      <img src={deluxeroom} className="d-block w-100" alt="rannabati"/>
    </div>
    <div className="carousel-item">
      <img src={Roomkrishnagar} className="d-block w-100" alt="rannabati"/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Premiumdeluxepage